import { useNavigate, useParams } from 'react-router-dom';
import MasterAdminShell, { type MasterAdminTab } from '../components/MasterAdminShell';
import StudentAssessmentHub from '../components/StudentAssessmentHub';
import { masterAdminStudentAssessmentPath, ROUTES } from '../lib/classroomRoutes';
import './OrgAdmin.css';
import './SystemAdmin.css';

export default function StudentAssessmentPage() {
  const navigate = useNavigate();
  const { studentKey = '' } = useParams<{ studentKey: string }>();

  const handleSectionChange = (section: MasterAdminTab) => {
    navigate(ROUTES.MASTER_ADMIN, { state: { activeSection: section } });
  };

  const handleBack = () => {
    navigate(ROUTES.MASTER_ADMIN, { state: { activeSection: 'Students' } });
  };

  if (!studentKey) {
    return (
      <MasterAdminShell
        activeSection="Students"
        onSectionChange={handleSectionChange}
        panelClassName="admin-panel-student-assessment"
      >
        <div className="org-panel-card student-assessment-hub">
          <p className="student-assessment-error">No student key provided.</p>
          <button type="button" className="student-assessment-back-btn" onClick={handleBack}>
            [ BACK TO STUDENTS LIST ]
          </button>
        </div>
      </MasterAdminShell>
    );
  }

  return (
    <MasterAdminShell
      activeSection="Students"
      onSectionChange={handleSectionChange}
      panelClassName="admin-panel-student-assessment"
    >
      <div className="student-assessment-page">
        <StudentAssessmentHub
          studentKey={decodeURIComponent(studentKey)}
          onBack={handleBack}
          onCertificationUpdated={() => {}}
        />
      </div>
    </MasterAdminShell>
  );
}
